export default __webpack_public_path__ + "static/media/docker.26ada6e4.svg";